import {
  PAYMENT_STATUS,
  PAYMENT_STATUS_LABELS
} from "../constants/payment.constants";


/*
|--------------------------------------------------------------------------
| FORMAT PAYMENT AMOUNT
|--------------------------------------------------------------------------
*/

export const formatPaymentAmount = (
  amount,
  currency = "INR"
) => {
  const numericAmount =
    Number(amount);


  if (!Number.isFinite(
    numericAmount
  )) {
    return "—";
  }


  try {
    return new Intl.NumberFormat(
      "en-IN",
      {
        style: "currency",
        currency,
        minimumFractionDigits: 2
      }
    ).format(numericAmount);

  } catch {
    return `${currency} ${numericAmount.toFixed(2)}`;
  }
};


/*
|--------------------------------------------------------------------------
| FORMAT PAYMENT DATE
|--------------------------------------------------------------------------
*/

export const formatPaymentDate = (
  date
) => {
  if (!date) {
    return "—";
  }


  const parsedDate =
    new Date(date);


  if (
    Number.isNaN(
      parsedDate.getTime()
    )
  ) {
    return "—";
  }


  return parsedDate.toLocaleString(
    "en-IN",
    {
      dateStyle: "medium",
      timeStyle: "short"
    }
  );
};


/*
|--------------------------------------------------------------------------
| PAYMENT STATUS LABEL
|--------------------------------------------------------------------------
*/

export const getPaymentStatusLabel = (
  status
) => {
  return (
    PAYMENT_STATUS_LABELS[
      status
    ] || status || "—"
  );
};


/*
|--------------------------------------------------------------------------
| PAYMENT STATUS VARIANT
|--------------------------------------------------------------------------
*/

export const getPaymentStatusVariant = (
  status
) => {
  switch (status) {
    case PAYMENT_STATUS.SUCCESS:
      return "success";

    case PAYMENT_STATUS.FAILED:
      return "danger";

    case PAYMENT_STATUS.CANCELLED:
      return "danger";

    case PAYMENT_STATUS.REFUNDED:
      return "secondary";

    case PAYMENT_STATUS.PROCESSING:
      return "warning";

    case PAYMENT_STATUS.PENDING:
      return "warning";

    default:
      return "secondary";
  }
};


/*
|--------------------------------------------------------------------------
| NORMALIZE PAYMENT
|--------------------------------------------------------------------------
*/

export const normalizePayment = (
  payment
) => {
  if (!payment) {
    return null;
  }


  return {
    ...payment,

    amount:
      Number(payment.amount || 0),

    currency:
      payment.currency || "INR",

    status:
      payment.status || PAYMENT_STATUS.PENDING,

    gateway:
      payment.gateway || "—"
  };
};


/*
|--------------------------------------------------------------------------
| PAYMENT CAN BE PAID
|--------------------------------------------------------------------------
*/

export const canMakePayment = (
  offer
) => {
  if (!offer) {
    return false;
  }


  if (
    offer.status !== "ACCEPTED"
  ) {
    return false;
  }


  if (
    offer.valid_until &&
    new Date(
      offer.valid_until
    ) < new Date()
  ) {
    return false;
  }


  return Number(
    offer.total_amount
  ) > 0;
};


/*
|--------------------------------------------------------------------------
| PAYMENT COMPLETED
|--------------------------------------------------------------------------
*/

export const isPaymentSuccessful = (
  payment
) => {
  return (
    payment?.status ===
    PAYMENT_STATUS.SUCCESS
  );
};
